import { Form } from "../../../core/entities/form";
import { InternalStatusCodes } from "../../../core/entities/formEvent";
import { mapErrorCodeToErrorText } from "../../../core/functions/MapErrorCodeToErrorText";
import { mapStatusCodeToStatusText } from "../../../core/functions/MapStatusCodeToStatusText";
import { FormDto } from "../formDto";
import { mapDtoToFormEvent } from "./mapDtoToFormEvent";
import { mapErrorCodesToErrorDescription } from "../../../core/functions/MapErrorCodesToErrorDescription";

export function mapDtoToForm(formDto: FormDto): Form {
    let et: string | undefined;
    if (formDto.currentStatus === InternalStatusCodes.DeclinedByDoctor) {
        const e = formDto.events.find(
            (x) => x.status === InternalStatusCodes.DeclinedByDoctor
        );
        et = e?.errorText;
    } else {
        et = formDto.currentError
            ? mapErrorCodeToErrorText(formDto.currentError)
            : undefined;
    }

    const currentError = formDto.events.find(
        (x) => x.status === formDto.currentStatus
    );
    return {
        id: formDto.id,
        formId: "N/A",
        citizenSsn: formDto.citizenSsn,
        citizenName: formDto.citizenName,
        citizensDoctorName: formDto.citizensDoctorName,
        municipalityCode: formDto.municipalityCode,
        municipalityName: formDto.municipalityName,
        createdAt: new Date(formDto.createdAt),
        currentStatusCode: formDto.currentStatus,
        currentStatusDescription: mapStatusCodeToStatusText(
            formDto.currentStatus
        ),
        currentErrorCode: formDto.currentError,
        currentErrorCodeHeader: et,
        currentErrorDescription: currentError
            ? mapErrorCodesToErrorDescription(
                  currentError.errorCode,
                  currentError.errorText
              )
            : undefined,
        events: formDto.events.map(mapDtoToFormEvent),
        documentId: formDto.documentId,
        citizensDoctorClinic: formDto.citizensDoctorClinic
    };
}
